var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "256px",
    width: "256px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.00 512.00",
    xmlSpace: "preserve",
    fill: "#fcf8f8",
    stroke: "#fcf8f8",
    strokeWidth: 7.680014999999999,
    transform: "matrix(-1, 0, 0, 1, 0, 0)rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#00b3ff",
    strokeWidth: 23.552045999999997
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB74A"
    },
    d: "M216.303,254.699c-104.616,0-191.005,78.035-204.136,179.073c-0.88,6.775,1.202,13.599,5.714,18.729 c4.512,5.13,11.015,8.06,17.847,8.06h361.149c6.826,0,13.319-2.943,17.827-8.068c4.508-5.126,6.613-11.953,5.734-18.722 C407.308,332.734,320.919,254.699,216.303,254.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC56E"
    },
    d: "M216.303,254.699c-104.616,0-191.004,78.035-204.135,179.073c-0.88,6.775,1.202,13.599,5.714,18.729 c4.512,5.13,11.015,8.06,17.847,8.06h180.574L216.303,254.699L216.303,254.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE9F40"
    },
    d: "M313.597,279.138c-28.977-15.573-62.094-24.439-97.294-24.439s-68.317,8.866-97.294,24.439 c22.858,33.968,57.935,55.735,97.294,55.735S290.739,313.105,313.597,279.138z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFDBAC"
    },
    cx: 216.3,
    cy: 148.763,
    rx: 124.718,
    ry: 148.763
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEED9"
    },
    d: "M216.303,0c-68.882,0-124.72,66.603-124.72,148.762s55.838,148.762,124.719,148.762V0H216.303z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#146691"
    },
    cx: 403.393,
    cy: 415.358,
    r: 96.639
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A85BD"
    },
    d: "M306.749,415.358c0,53.375,43.268,96.643,96.643,96.643V318.715 C350.017,318.715,306.749,361.983,306.749,415.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BBBED"
    },
    d: "M441.742,398.644h-21.636h-33.427h-21.638c-9.23,0-16.714,7.483-16.714,16.714 c0,9.23,7.483,16.714,16.714,16.714h21.638h33.427h21.636c9.23,0,16.714-7.483,16.714-16.714 C458.456,406.128,450.974,398.644,441.742,398.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80C8ED"
    },
    d: "M403.392,432.072v-33.427h-16.714h-21.638c-9.23,0-16.714,7.483-16.714,16.714 c0,9.23,7.483,16.714,16.714,16.714h21.638H403.392z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB74A"
    },
    d: "M216.303,254.699c-104.616,0-191.005,78.035-204.136,179.073c-0.88,6.775,1.202,13.599,5.714,18.729 c4.512,5.13,11.015,8.06,17.847,8.06h361.149c6.826,0,13.319-2.943,17.827-8.068c4.508-5.126,6.613-11.953,5.734-18.722 C407.308,332.734,320.919,254.699,216.303,254.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC56E"
    },
    d: "M216.303,254.699c-104.616,0-191.004,78.035-204.135,179.073c-0.88,6.775,1.202,13.599,5.714,18.729 c4.512,5.13,11.015,8.06,17.847,8.06h180.574L216.303,254.699L216.303,254.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE9F40"
    },
    d: "M313.597,279.138c-28.977-15.573-62.094-24.439-97.294-24.439s-68.317,8.866-97.294,24.439 c22.858,33.968,57.935,55.735,97.294,55.735S290.739,313.105,313.597,279.138z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFDBAC"
    },
    cx: 216.3,
    cy: 148.763,
    rx: 124.718,
    ry: 148.763
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEED9"
    },
    d: "M216.303,0c-68.882,0-124.72,66.603-124.72,148.762s55.838,148.762,124.719,148.762V0H216.303z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#146691"
    },
    cx: 403.393,
    cy: 415.358,
    r: 96.639
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A85BD"
    },
    d: "M306.749,415.358c0,53.375,43.268,96.643,96.643,96.643V318.715 C350.017,318.715,306.749,361.983,306.749,415.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BBBED"
    },
    d: "M441.742,398.644h-21.636h-33.427h-21.638c-9.23,0-16.714,7.483-16.714,16.714 c0,9.23,7.483,16.714,16.714,16.714h21.638h33.427h21.636c9.23,0,16.714-7.483,16.714-16.714 C458.456,406.128,450.974,398.644,441.742,398.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80C8ED"
    },
    d: "M403.392,432.072v-33.427h-16.714h-21.638c-9.23,0-16.714,7.483-16.714,16.714 c0,9.23,7.483,16.714,16.714,16.714h21.638H403.392z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.8f96058a63797f96647202ac3dcd2bb6.svg";
export { ForwardRef as ReactComponent };